import { Link } from 'react-router-dom';
import Container from '@/components/base/Container';
import SectionHeading from '@/components/base/SectionHeading';
import { categories, topics } from '@/mocks/topics';

export default function CategoryGrid() {
  const list = categories.filter((category) => category.id !== 'all');

  const countOf = (id: string) => topics.filter((topic) => topic.category === id).length;

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <Container>
        <SectionHeading
          eyebrow="Categories"
          title="主题分类"
          desc="按内容方向浏览正在追踪的线索，找到你最关心的那一类。"
          linkText="查看全部追踪"
          linkPath="/tracking"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((category, index) => (
            <Link
              key={category.id}
              to={`/tracking?cat=${category.id}`}
              className={`group flex cursor-pointer items-start gap-4 rounded-lg border border-background-200 p-5 transition-colors hover:border-primary-300 ${
                index === 0 ? 'bg-accent-50' : 'bg-background-100'
              }`}
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-background-50 text-primary-600">
                <i className={`${category.icon} text-2xl`}></i>
              </span>
              <span className="min-w-0">
                <span className="flex items-center gap-2">
                  <span className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                    {category.name}
                  </span>
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900">
                    {countOf(category.id)} 条
                  </span>
                </span>
                <span className="mt-1.5 block text-sm leading-relaxed text-foreground-600">{category.desc}</span>
              </span>
              <i className="ri-arrow-right-up-line ml-auto shrink-0 text-foreground-400 transition-colors group-hover:text-primary-600"></i>
            </Link>
          ))}
        </div>
      </Container>
    </section>
  );
}